"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.make = void 0;
// any allowed here to allow "any enum"
// eslint-disable-next-line @typescript-eslint/no-explicit-any

const make = function (event, props) {
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date(Date.now()).toISOString();
  return {
    ...event,
    timestamp: new Date(now).toISOString(),
    props
  };
};
exports.make = make;